import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

interface IPayload {
  startDate: string | null;
  endDate: string | null;
  fineStatus: string;
  createdBy: string;
  offenceCode: string;
  pageNumber: number;
  perPage: number;
  sortingOn: string;
  isDescending: boolean;
  reportType?: string;
}

const getReportUrl = (reportType?: string) => {
  switch (reportType) {
    case "Fines Report":
      return "api/Reports/GetFinesReport";
    case "Collection Report":
      return "api/Reports/GetCollectionReport";
    case "Agent Collection Report":
      return "api/Reports/GetAgentCollectionReport";
    case "Station Performance Report":
      return "api/Reports/GetStationPerformanceReport";
    default:
      return "api/Reports/GetStationPerformanceReport";
  }
};

export const getReportData = createAsyncThunk(
  "reports/finesReport",
  async (data: IPayload) => {
    const url = getReportUrl(data.reportType);
    const response: any = await axios.post(url, data);
    return {
      ...(response.data || response?.response?.data),
      reportType: data.reportType,
    };
  }
);

export const reportsSlice = createSlice({
  name: "reports",
  initialState: {
    data: {
      totalRecords: 0,
      totalPages: 0,
      list: [],
      summary: [] as Record<string, unknown>[],
    },
    loading: false,
    pageProps: {
      isDescending: false,
      pageNumber: 1,
      perPage: 10,
      searchText: "",
      sortingOn: "",
      startDate: "",
      endDate: "",
      fineStatus: "all",
      createdBy: "all",
      offenceCode: "all",
      reportType: "",
    },
  },
  reducers: {
    onChangeReportsList: (state, action) => {
      state.pageProps = action.payload;
    },
    clearReportsData: (state) => {
      state.data = {
        totalRecords: 0,
        totalPages: 0,
        list: [],
        summary: [],
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getReportData.pending, (state) => {
        state.loading = true;
      })
      .addCase(getReportData.fulfilled, (state, action) => {
        state.loading = false;
        const result = action.payload?.result ?? {};
        if (action.payload?.reportType === "Agent Collection Report") {
          const logEntries = result.logEntries ?? {};
          state.data = {
            ...logEntries,
            summary: result.summary ?? [],
          };
        } else {
          state.data = { ...result, summary: [] };
        }
      })
      .addCase(getReportData.rejected, (state) => {
        state.loading = false;
      });
  },
});
export const { onChangeReportsList, clearReportsData } = reportsSlice.actions;

export default reportsSlice.reducer;
